import apiClient from './httpInterceptor';

export class CloudApi {

    constructor() {
        this.url = "https://backend.cvis.videri.ai";
    }

    async login(username, password) {
        const url = this.url + "/manage/api/v1/login";
        const payload = {
            username: username,
            password: password,
            flag: 1
        }
        const result = await apiClient.post(url, payload);
        return result.data;
    }

    async getDevices(workspaceId) {
        const url = this.url + `/manage/api/v1/devices/${workspaceId}/devices`;
        const result = await apiClient.get(url);
        return result.data;
    }


}